import { Store } from 'vuex';
import { Plugin } from 'vue';
import VueNativeSock from 'vue-native-websocket-vue3';
import { boot } from 'quasar/wrappers';
import { getOptions } from 'src/services/connection';
import { StateInterface } from 'src/store';

export default boot(({ app, store }) => {
  const { url, options } = getOptions(app, store as Store<StateInterface>);

  app.use(VueNativeSock as Plugin, url, options);
});
